import RandomTeams from '../../random-teams';

export class RandomPartnersInCrimeTeams extends RandomTeams {}

export default RandomPartnersInCrimeTeams;
